import NotFound from "pages/NotFound";
import AssessmentForm from "pages/AssessmentForm";
import PrivacyNotice from "pages/PrivacyNotice";
import DisabilitySupplement from "pages/DisabilitySupplement";
import RegistrationForm from "pages/RegistrationForm";

export const routes = [
    {
        path: "/",
        element: <AssessmentForm />
    },
    {
        path: "/registration",
        element: <RegistrationForm />
    },
    {
        path: "/privacy-notice",
        element: <PrivacyNotice />
    },
    {
        path: "/disability-supplement",
        element: <DisabilitySupplement />
    },
    {
        path: "/*",
        element: <NotFound />
    },
]

export const countryPhoneCodes = [
    {
        value: "+7 840",
        label: "+7 840 - Abkhazia"
    },
    {
        value: "+93",
        label: "+93 - Afghanistan"
    },
    {
        value: "+355",
        label: "+355 - Albania"
    },
    {
        value: "+213",
        label: "+213 - Algeria"
    },
    {
        value: "+1 684",
        label: "+1 684 - American Samoa"
    },
    {
        value: "+376",
        label: "+376 - Andorra"
    },
    {
        value: "+244",
        label: "+244 - Angola"
    },
    {
        value: "+1 264",
        label: "+1 264 - Anguilla"
    },
    {
        value: "+1 268",
        label: "+1 268 - Antigua and Barbuda"
    },
    {
        value: "+54",
        label: "+54 - Argentina"
    },
    {
        value: "+374",
        label: "+374 - Armenia"
    },
    {
        value: "+297",
        label: "+297 - Aruba"
    },
    {
        value: "+247",
        label: "+247 - Ascension"
    },
    {
        value: "+61",
        label: "+61 - Australia"
    },
    {
        value: "+672",
        label: "+672 - Australian External Territories"
    },
    {
        value: "+43",
        label: "+43 - Austria"
    },
    {
        value: "+994",
        label: "+994 - Azerbaijan"
    },
    {
        value: "+1 242",
        label: "+1 242 - Bahamas"
    },
    {
        value: "+973",
        label: "+973 - Bahrain"
    },
    {
        value: "+880",
        label: "+880 - Bangladesh"
    },
    {
        value: "+1 246",
        label: "+1 246 - Barbados"
    },
    {
        value: "+1 268",
        label: "+1 268 - Barbuda"
    },
    {
        value: "+375",
        label: "+375 - Belarus"
    },
    {
        value: "+32",
        label: "+32 - Belgium"
    },
    {
        value: "+501",
        label: "+501 - Belize"
    },
    {
        value: "+229",
        label: "+229 - Benin"
    },
    {
        value: "+1 441",
        label: "+1 441 - Bermuda"
    },
    {
        value: "+975",
        label: "+975 - Bhutan"
    },
    {
        value: "+591",
        label: "+591 - Bolivia"
    },
    {
        value: "+387",
        label: "+387 - Bosnia and Herzegovina"
    },
    {
        value: "+267",
        label: "+267 - Botswana"
    },
    {
        value: "+55",
        label: "+55 - Brazil"
    },
    {
        value: "+246",
        label: "+246 - British Indian Ocean Territory"
    },
    {
        value: "+1 284",
        label: "+1 284 - British Virgin Islands"
    },
    {
        value: "+673",
        label: "+673 - Brunei"
    },
    {
        value: "+359",
        label: "+359 - Bulgaria"
    },
    {
        value: "+226",
        label: "+226 - Burkina Faso"
    },
    {
        value: "+257",
        label: "+257 - Burundi"
    },
    {
        value: "+855",
        label: "+855 - Cambodia"
    },
    {
        value: "+237",
        label: "+237 - Cameroon"
    },
    {
        value: "+1",
        label: "+1 - Canada"
    },
    {
        value: "+238",
        label: "+238 - Cape Verde"
    },
    {
        value: "+ 345",
        label: "+ 345 - Cayman Islands"
    },
    {
        value: "+236",
        label: "+236 - Central African Republic"
    },
    {
        value: "+235",
        label: "+235 - Chad"
    },
    {
        value: "+56",
        label: "+56 - Chile"
    },
    {
        value: "+86",
        label: "+86 - China"
    },
    {
        value: "+61",
        label: "+61 - Christmas Island"
    },
    {
        value: "+61",
        label: "+61 - Cocos-Keeling Islands"
    },
    {
        value: "+57",
        label: "+57 - Colombia"
    },
    {
        value: "+269",
        label: "+269 - Comoros"
    },
    {
        value: "+242",
        label: "+242 - Congo"
    },
    {
        value: "+243",
        label: "+243 - Congo, Dem. Rep. of (Zaire)"
    },
    {
        value: "+682",
        label: "+682 - Cook Islands"
    },
    {
        value: "+506",
        label: "+506 - Costa Rica"
    },
    {
        value: "+385",
        label: "+385 - Croatia"
    },
    {
        value: "+53",
        label: "+53 - Cuba"
    },
    {
        value: "+599",
        label: "+599 - Curacao"
    },
    {
        value: "+537",
        label: "+537 - Cyprus"
    },
    {
        value: "+420",
        label: "+420 - Czech Republic"
    },
    {
        value: "+45",
        label: "+45 - Denmark"
    },
    {
        value: "+246",
        label: "+246 - Diego Garcia"
    },
    {
        value: "+253",
        label: "+253 - Djibouti"
    },
    {
        value: "+1 767",
        label: "+1 767 - Dominica"
    },
    {
        value: "+1 809",
        label: "+1 809 - Dominican Republic"
    },
    {
        value: "+670",
        label: "+670 - East Timor"
    },
    {
        value: "+56",
        label: "+56 - Easter Island"
    },
    {
        value: "+593",
        label: "+593 - Ecuador"
    },
    {
        value: "+20",
        label: "+20 - Egypt"
    },
    {
        value: "+503",
        label: "+503 - El Salvador"
    },
    {
        value: "+240",
        label: "+240 - Equatorial Guinea"
    },
    {
        value: "+291",
        label: "+291 - Eritrea"
    },
    {
        value: "+372",
        label: "+372 - Estonia"
    },
    {
        value: "+251",
        label: "+251 - Ethiopia"
    },
    {
        value: "+500",
        label: "+500 - Falkland Islands"
    },
    {
        value: "+298",
        label: "+298 - Faroe Islands"
    },
    {
        value: "+679",
        label: "+679 - Fiji"
    },
    {
        value: "+358",
        label: "+358 - Finland"
    },
    {
        value: "+33",
        label: "+33 - France"
    },
    {
        value: "+596",
        label: "+596 - French Antilles"
    },
    {
        value: "+594",
        label: "+594 - French Guiana"
    },
    {
        value: "+689",
        label: "+689 - French Polynesia"
    },
    {
        value: "+241",
        label: "+241 - Gabon"
    },
    {
        value: "+220",
        label: "+220 - Gambia"
    },
    {
        value: "+995",
        label: "+995 - Georgia"
    },
    {
        value: "+49",
        label: "+49 - Germany"
    },
    {
        value: "+233",
        label: "+233 - Ghana"
    },
    {
        value: "+350",
        label: "+350 - Gibraltar"
    },
    {
        value: "+30",
        label: "+30 - Greece"
    },
    {
        value: "+299",
        label: "+299 - Greenland"
    },
    {
        value: "+1 473",
        label: "+1 473 - Grenada"
    },
    {
        value: "+590",
        label: "+590 - Guadeloupe"
    },
    {
        value: "+1 671",
        label: "+1 671 - Guam"
    },
    {
        value: "+502",
        label: "+502 - Guatemala"
    },
    {
        value: "+224",
        label: "+224 - Guinea"
    },
    {
        value: "+245",
        label: "+245 - Guinea-Bissau"
    },
    {
        value: "+595",
        label: "+595 - Guyana"
    },
    {
        value: "+509",
        label: "+509 - Haiti"
    },
    {
        value: "+504",
        label: "+504 - Honduras"
    },
    {
        value: "+852",
        label: "+852 - Hong Kong SAR China"
    },
    {
        value: "+36",
        label: "+36 - Hungary"
    },
    {
        value: "+354",
        label: "+354 - Iceland"
    },
    {
        value: "+91",
        label: "+91 - India"
    },
    {
        value: "+62",
        label: "+62 - Indonesia"
    },
    {
        value: "+98",
        label: "+98 - Iran"
    },
    {
        value: "+964",
        label: "+964 - Iraq"
    },
    {
        value: "+353",
        label: "+353 - Ireland"
    },
    {
        value: "+972",
        label: "+972 - Israel"
    },
    {
        value: "+39",
        label: "+39 - Italy"
    },
    {
        value: "+225",
        label: "+225 - Ivory Coast"
    },
    {
        value: "+1 876",
        label: "+1 876 - Jamaica"
    },
    {
        value: "+81",
        label: "+81 - Japan"
    },
    {
        value: "+962",
        label: "+962 - Jordan"
    },
    {
        value: "+7 7",
        label: "+7 7 - Kazakhstan"
    },
    {
        value: "+254",
        label: "+254 - Kenya"
    },
    {
        value: "+686",
        label: "+686 - Kiribati"
    },
    {
        value: "+965",
        label: "+965 - Kuwait"
    },
    {
        value: "+996",
        label: "+996 - Kyrgyzstan"
    },
    {
        value: "+856",
        label: "+856 - Laos"
    },
    {
        value: "+371",
        label: "+371 - Latvia"
    },
    {
        value: "+961",
        label: "+961 - Lebanon"
    },
    {
        value: "+266",
        label: "+266 - Lesotho"
    },
    {
        value: "+231",
        label: "+231 - Liberia"
    },
    {
        value: "+218",
        label: "+218 - Libya"
    },
    {
        value: "+423",
        label: "+423 - Liechtenstein"
    },
    {
        value: "+370",
        label: "+370 - Lithuania"
    },
    {
        value: "+352",
        label: "+352 - Luxembourg"
    },
    {
        value: "+853",
        label: "+853 - Macau SAR China"
    },
    {
        value: "+389",
        label: "+389 - Macedonia"
    },
    {
        value: "+261",
        label: "+261 - Madagascar"
    },
    {
        value: "+265",
        label: "+265 - Malawi"
    },
    {
        value: "+60",
        label: "+60 - Malaysia"
    },
    {
        value: "+960",
        label: "+960 - Maldives"
    },
    {
        value: "+223",
        label: "+223 - Mali"
    },
    {
        value: "+356",
        label: "+356 - Malta"
    },
    {
        value: "+692",
        label: "+692 - Marshall Islands"
    },
    {
        value: "+596",
        label: "+596 - Martinique"
    },
    {
        value: "+222",
        label: "+222 - Mauritania"
    },
    {
        value: "+230",
        label: "+230 - Mauritius"
    },
    {
        value: "+262",
        label: "+262 - Mayotte"
    },
    {
        value: "+52",
        label: "+52 - Mexico"
    },
    {
        value: "+691",
        label: "+691 - Micronesia"
    },
    {
        value: "+1 808",
        label: "+1 808 - Midway Island"
    },
    {
        value: "+373",
        label: "+373 - Moldova"
    },
    {
        value: "+377",
        label: "+377 - Monaco"
    },
    {
        value: "+976",
        label: "+976 - Mongolia"
    },
    {
        value: "+382",
        label: "+382 - Montenegro"
    },
    {
        value: "+1664",
        label: "+1664 - Montserrat"
    },
    {
        value: "+212",
        label: "+212 - Morocco"
    },
    {
        value: "+95",
        label: "+95 - Myanmar"
    },
    {
        value: "+264",
        label: "+264 - Namibia"
    },
    {
        value: "+674",
        label: "+674 - Nauru"
    },
    {
        value: "+977",
        label: "+977 - Nepal"
    },
    {
        value: "+31",
        label: "+31 - Netherlands"
    },
    {
        value: "+599",
        label: "+599 - Netherlands Antilles"
    },
    {
        value: "+1 869",
        label: "+1 869 - Nevis"
    },
    {
        value: "+687",
        label: "+687 - New Caledonia"
    },
    {
        value: "+64",
        label: "+64 - New Zealand"
    },
    {
        value: "+505",
        label: "+505 - Nicaragua"
    },
    {
        value: "+227",
        label: "+227 - Niger"
    },
    {
        value: "+234",
        label: "+234 - Nigeria"
    },
    {
        value: "+683",
        label: "+683 - Niue"
    },
    {
        value: "+672",
        label: "+672 - Norfolk Island"
    },
    {
        value: "+850",
        label: "+850 - North Korea"
    },
    {
        value: "+1 670",
        label: "+1 670 - Northern Mariana Islands"
    },
    {
        value: "+47",
        label: "+47 - Norway"
    },
    {
        value: "+968",
        label: "+968 - Oman"
    },
    {
        value: "+92",
        label: "+92 - Pakistan"
    },
    {
        value: "+680",
        label: "+680 - Palau"
    },
    {
        value: "+970",
        label: "+970 - Palestinian Territory"
    },
    {
        value: "+507",
        label: "+507 - Panama"
    },
    {
        value: "+675",
        label: "+675 - Papua New Guinea"
    },
    {
        value: "+595",
        label: "+595 - Paraguay"
    },
    {
        value: "+51",
        label: "+51 - Peru"
    },
    {
        value: "+63",
        label: "+63 - Philippines"
    },
    {
        value: "+48",
        label: "+48 - Poland"
    },
    {
        value: "+351",
        label: "+351 - Portugal"
    },
    {
        value: "+1 787",
        label: "+1 787 - Puerto Rico"
    },
    {
        value: "+974",
        label: "+974 - Qatar"
    },
    {
        value: "+262",
        label: "+262 - Reunion"
    },
    {
        value: "+40",
        label: "+40 - Romania"
    },
    {
        value: "+7",
        label: "+7 - Russia"
    },
    {
        value: "+250",
        label: "+250 - Rwanda"
    },
    {
        value: "+685",
        label: "+685 - Samoa"
    },
    {
        value: "+378",
        label: "+378 - San Marino"
    },
    {
        value: "+966",
        label: "+966 - Saudi Arabia"
    },
    {
        value: "+221",
        label: "+221 - Senegal"
    },
    {
        value: "+381",
        label: "+381 - Serbia"
    },
    {
        value: "+248",
        label: "+248 - Seychelles"
    },
    {
        value: "+232",
        label: "+232 - Sierra Leone"
    },
    {
        value: "+65",
        label: "+65 - Singapore"
    },
    {
        value: "+421",
        label: "+421 - Slovakia"
    },
    {
        value: "+386",
        label: "+386 - Slovenia"
    },
    {
        value: "+677",
        label: "+677 - Solomon Islands"
    },
    {
        value: "+27",
        label: "+27 - South Africa"
    },
    {
        value: "+500",
        label: "+500 - South Georgia and the South Sandwich Islands"
    },
    {
        value: "+82",
        label: "+82 - South Korea"
    },
    {
        value: "+34",
        label: "+34 - Spain"
    },
    {
        value: "+94",
        label: "+94 - Sri Lanka"
    },
    {
        value: "+249",
        label: "+249 - Sudan"
    },
    {
        value: "+597",
        label: "+597 - Suriname"
    },
    {
        value: "+268",
        label: "+268 - Swaziland"
    },
    {
        value: "+46",
        label: "+46 - Sweden"
    },
    {
        value: "+41",
        label: "+41 - Switzerland"
    },
    {
        value: "+963",
        label: "+963 - Syria"
    },
    {
        value: "+886",
        label: "+886 - Taiwan"
    },
    {
        value: "+992",
        label: "+992 - Tajikistan"
    },
    {
        value: "+255",
        label: "+255 - Tanzania"
    },
    {
        value: "+66",
        label: "+66 - Thailand"
    },
    {
        value: "+670",
        label: "+670 - Timor Leste"
    },
    {
        value: "+228",
        label: "+228 - Togo"
    },
    {
        value: "+690",
        label: "+690 - Tokelau"
    },
    {
        value: "+676",
        label: "+676 - Tonga"
    },
    {
        value: "+1 868",
        label: "+1 868 - Trinidad and Tobago"
    },
    {
        value: "+216",
        label: "+216 - Tunisia"
    },
    {
        value: "+90",
        label: "+90 - Turkey"
    },
    {
        value: "+993",
        label: "+993 - Turkmenistan"
    },
    {
        value: "+1 649",
        label: "+1 649 - Turks and Caicos Islands"
    },
    {
        value: "+688",
        label: "+688 - Tuvalu"
    },
    {
        value: "+1 340",
        label: "+1 340 - U.S. Virgin Islands"
    },
    {
        value: "+256",
        label: "+256 - Uganda"
    },
    {
        value: "+380",
        label: "+380 - Ukraine"
    },
    {
        value: "+971",
        label: "+971 - United Arab Emirates"
    },
    {
        value: "+44",
        label: "+44 - United Kingdom"
    },
    {
        value: "+1",
        label: "+1 - United States"
    },
    {
        value: "+598",
        label: "+598 - Uruguay"
    },
    {
        value: "+998",
        label: "+998 - Uzbekistan"
    },
    {
        value: "+678",
        label: "+678 - Vanuatu"
    },
    {
        value: "+58",
        label: "+58 - Venezuela"
    },
    {
        value: "+84",
        label: "+84 - Vietnam"
    },
    {
        value: "+1 808",
        label: "+1 808 - Wake Island"
    },
    {
        value: "+681",
        label: "+681 - Wallis and Futuna"
    },
    {
        value: "+967",
        label: "+967 - Yemen"
    },
    {
        value: "+260",
        label: "+260 - Zambia"
    },
    {
        value: "+255",
        label: "+255 - Zanzibar"
    },
    {
        value: "+263",
        label: "+263 - Zimbabwe"
    }
]

export const countries = [
    {
        value: "Abkhazia",
        label: "Abkhazia"
    },
    {
        value: "Afghanistan",
        label: "Afghanistan"
    },
    {
        value: "Albania",
        label: "Albania"
    },
    {
        value: "Algeria",
        label: "Algeria"
    },
    {
        value: "American Samoa",
        label: "American Samoa"
    },
    {
        value: "Andorra",
        label: "Andorra"
    },
    {
        value: "Angola",
        label: "Angola"
    },
    {
        value: "Anguilla",
        label: "Anguilla"
    },
    {
        value: "Antigua and Barbuda",
        label: "Antigua and Barbuda"
    },
    {
        value: "Argentina",
        label: "Argentina"
    },
    {
        value: "Armenia",
        label: "Armenia"
    },
    {
        value: "Aruba",
        label: "Aruba"
    },
    {
        value: "Ascension",
        label: "Ascension"
    },
    // {
    //     value: "Australia",
    //     label: "Australia"
    // },
    {
        value: "Australian External Territories",
        label: "Australian External Territories"
    },
    {
        value: "Austria",
        label: "Austria"
    },
    {
        value: "Azerbaijan",
        label: "Azerbaijan"
    },
    {
        value: "Bahamas",
        label: "Bahamas"
    },
    {
        value: "Bahrain",
        label: "Bahrain"
    },
    {
        value: "Bangladesh",
        label: "Bangladesh"
    },
    {
        value: "Barbados",
        label: "Barbados"
    },
    {
        value: "Barbuda",
        label: "Barbuda"
    },
    {
        value: "Belarus",
        label: "Belarus"
    },
    {
        value: "Belgium",
        label: "Belgium"
    },
    {
        value: "Belize",
        label: "Belize"
    },
    {
        value: "Benin",
        label: "Benin"
    },
    {
        value: "Bermuda",
        label: "Bermuda"
    },
    {
        value: "Bhutan",
        label: "Bhutan"
    },
    {
        value: "Bolivia",
        label: "Bolivia"
    },
    {
        value: "Bosnia and Herzegovina",
        label: "Bosnia and Herzegovina"
    },
    {
        value: "Botswana",
        label: "Botswana"
    },
    {
        value: "Brazil",
        label: "Brazil"
    },
    {
        value: "British Indian Ocean Territory",
        label: "British Indian Ocean Territory"
    },
    {
        value: "British Virgin Islands",
        label: "British Virgin Islands"
    },
    {
        value: "Brunei",
        label: "Brunei"
    },
    {
        value: "Bulgaria",
        label: "Bulgaria"
    },
    {
        value: "Burkina Faso",
        label: "Burkina Faso"
    },
    {
        value: "Burundi",
        label: "Burundi"
    },
    {
        value: "Cambodia",
        label: "Cambodia"
    },
    {
        value: "Cameroon",
        label: "Cameroon"
    },
    {
        value: "Canada",
        label: "Canada"
    },
    {
        value: "Cape Verde",
        label: "Cape Verde"
    },
    {
        value: "Cayman Islands",
        label: "Cayman Islands"
    },
    {
        value: "Central African Republic",
        label: "Central African Republic"
    },
    {
        value: "Chad",
        label: "Chad"
    },
    {
        value: "Chile",
        label: "Chile"
    },
    {
        value: "China",
        label: "China"
    },
    {
        value: "Christmas Island",
        label: "Christmas Island"
    },
    {
        value: "Cocos-Keeling Islands",
        label: "Cocos-Keeling Islands"
    },
    {
        value: "Colombia",
        label: "Colombia"
    },
    {
        value: "Comoros",
        label: "Comoros"
    },
    {
        value: "Congo",
        label: "Congo"
    },
    {
        value: "Congo, Dem. Rep. of (Zaire)",
        label: "Congo, Dem. Rep. of (Zaire)"
    },
    {
        value: "Cook Islands",
        label: "Cook Islands"
    },
    {
        value: "Costa Rica",
        label: "Costa Rica"
    },
    {
        value: "Croatia",
        label: "Croatia"
    },
    {
        value: "Cuba",
        label: "Cuba"
    },
    {
        value: "Curacao",
        label: "Curacao"
    },
    {
        value: "Cyprus",
        label: "Cyprus"
    },
    {
        value: "Czech Republic",
        label: "Czech Republic"
    },
    {
        value: "Denmark",
        label: "Denmark"
    },
    {
        value: "Diego Garcia",
        label: "Diego Garcia"
    },
    {
        value: "Djibouti",
        label: "Djibouti"
    },
    {
        value: "Dominica",
        label: "Dominica"
    },
    {
        value: "Dominican Republic",
        label: "Dominican Republic"
    },
    {
        value: "East Timor",
        label: "East Timor"
    },
    {
        value: "Easter Island",
        label: "Easter Island"
    },
    {
        value: "Ecuador",
        label: "Ecuador"
    },
    {
        value: "Egypt",
        label: "Egypt"
    },
    {
        value: "El Salvador",
        label: "El Salvador"
    },
    {
        value: "Equatorial Guinea",
        label: "Equatorial Guinea"
    },
    {
        value: "Eritrea",
        label: "Eritrea"
    },
    {
        value: "Estonia",
        label: "Estonia"
    },
    {
        value: "Ethiopia",
        label: "Ethiopia"
    },
    {
        value: "Falkland Islands",
        label: "Falkland Islands"
    },
    {
        value: "Faroe Islands",
        label: "Faroe Islands"
    },
    {
        value: "Fiji",
        label: "Fiji"
    },
    {
        value: "Finland",
        label: "Finland"
    },
    {
        value: "France",
        label: "France"
    },
    {
        value: "French Antilles",
        label: "French Antilles"
    },
    {
        value: "French Guiana",
        label: "French Guiana"
    },
    {
        value: "French Polynesia",
        label: "French Polynesia"
    },
    {
        value: "Gabon",
        label: "Gabon"
    },
    {
        value: "Gambia",
        label: "Gambia"
    },
    {
        value: "Georgia",
        label: "Georgia"
    },
    {
        value: "Germany",
        label: "Germany"
    },
    {
        value: "Ghana",
        label: "Ghana"
    },
    {
        value: "Gibraltar",
        label: "Gibraltar"
    },
    {
        value: "Greece",
        label: "Greece"
    },
    {
        value: "Greenland",
        label: "Greenland"
    },
    {
        value: "Grenada",
        label: "Grenada"
    },
    {
        value: "Guadeloupe",
        label: "Guadeloupe"
    },
    {
        value: "Guam",
        label: "Guam"
    },
    {
        value: "Guatemala",
        label: "Guatemala"
    },
    {
        value: "Guinea",
        label: "Guinea"
    },
    {
        value: "Guinea-Bissau",
        label: "Guinea-Bissau"
    },
    {
        value: "Guyana",
        label: "Guyana"
    },
    {
        value: "Haiti",
        label: "Haiti"
    },
    {
        value: "Honduras",
        label: "Honduras"
    },
    {
        value: "Hong Kong SAR China",
        label: "Hong Kong SAR China"
    },
    {
        value: "Hungary",
        label: "Hungary"
    },
    {
        value: "Iceland",
        label: "Iceland"
    },
    {
        value: "India",
        label: "India"
    },
    {
        value: "Indonesia",
        label: "Indonesia"
    },
    {
        value: "Iran",
        label: "Iran"
    },
    {
        value: "Iraq",
        label: "Iraq"
    },
    {
        value: "Ireland",
        label: "Ireland"
    },
    {
        value: "Israel",
        label: "Israel"
    },
    {
        value: "Italy",
        label: "Italy"
    },
    {
        value: "Ivory Coast",
        label: "Ivory Coast"
    },
    {
        value: "Jamaica",
        label: "Jamaica"
    },
    {
        value: "Japan",
        label: "Japan"
    },
    {
        value: "Jordan",
        label: "Jordan"
    },
    {
        value: "Kazakhstan",
        label: "Kazakhstan"
    },
    {
        value: "Kenya",
        label: "Kenya"
    },
    {
        value: "Kiribati",
        label: "Kiribati"
    },
    {
        value: "Kuwait",
        label: "Kuwait"
    },
    {
        value: "Kyrgyzstan",
        label: "Kyrgyzstan"
    },
    {
        value: "Laos",
        label: "Laos"
    },
    {
        value: "Latvia",
        label: "Latvia"
    },
    {
        value: "Lebanon",
        label: "Lebanon"
    },
    {
        value: "Lesotho",
        label: "Lesotho"
    },
    {
        value: "Liberia",
        label: "Liberia"
    },
    {
        value: "Libya",
        label: "Libya"
    },
    {
        value: "Liechtenstein",
        label: "Liechtenstein"
    },
    {
        value: "Lithuania",
        label: "Lithuania"
    },
    {
        value: "Luxembourg",
        label: "Luxembourg"
    },
    {
        value: "Macau SAR China",
        label: "Macau SAR China"
    },
    {
        value: "Macedonia",
        label: "Macedonia"
    },
    {
        value: "Madagascar",
        label: "Madagascar"
    },
    {
        value: "Malawi",
        label: "Malawi"
    },
    {
        value: "Malaysia",
        label: "Malaysia"
    },
    {
        value: "Maldives",
        label: "Maldives"
    },
    {
        value: "Mali",
        label: "Mali"
    },
    {
        value: "Malta",
        label: "Malta"
    },
    {
        value: "Marshall Islands",
        label: "Marshall Islands"
    },
    {
        value: "Martinique",
        label: "Martinique"
    },
    {
        value: "Mauritania",
        label: "Mauritania"
    },
    {
        value: "Mauritius",
        label: "Mauritius"
    },
    {
        value: "Mayotte",
        label: "Mayotte"
    },
    {
        value: "Mexico",
        label: "Mexico"
    },
    {
        value: "Micronesia",
        label: "Micronesia"
    },
    {
        value: "Midway Island",
        label: "Midway Island"
    },
    {
        value: "Moldova",
        label: "Moldova"
    },
    {
        value: "Monaco",
        label: "Monaco"
    },
    {
        value: "Mongolia",
        label: "Mongolia"
    },
    {
        value: "Montenegro",
        label: "Montenegro"
    },
    {
        value: "Montserrat",
        label: "Montserrat"
    },
    {
        value: "Morocco",
        label: "Morocco"
    },
    {
        value: "Myanmar",
        label: "Myanmar"
    },
    {
        value: "Namibia",
        label: "Namibia"
    },
    {
        value: "Nauru",
        label: "Nauru"
    },
    {
        value: "Nepal",
        label: "Nepal"
    },
    {
        value: "Netherlands",
        label: "Netherlands"
    },
    {
        value: "Netherlands Antilles",
        label: "Netherlands Antilles"
    },
    {
        value: "Nevis",
        label: "Nevis"
    },
    {
        value: "New Caledonia",
        label: "New Caledonia"
    },
    {
        value: "New Zealand",
        label: "New Zealand"
    },
    {
        value: "Nicaragua",
        label: "Nicaragua"
    },
    {
        value: "Niger",
        label: "Niger"
    },
    {
        value: "Nigeria",
        label: "Nigeria"
    },
    {
        value: "Niue",
        label: "Niue"
    },
    {
        value: "Norfolk Island",
        label: "Norfolk Island"
    },
    {
        value: "North Korea",
        label: "North Korea"
    },
    {
        value: "Northern Mariana Islands",
        label: "Northern Mariana Islands"
    },
    {
        value: "Norway",
        label: "Norway"
    },
    {
        value: "Oman",
        label: "Oman"
    },
    {
        value: "Pakistan",
        label: "Pakistan"
    },
    {
        value: "Palau",
        label: "Palau"
    },
    {
        value: "Palestinian Territory",
        label: "Palestinian Territory"
    },
    {
        value: "Panama",
        label: "Panama"
    },
    {
        value: "Papua New Guinea",
        label: "Papua New Guinea"
    },
    {
        value: "Paraguay",
        label: "Paraguay"
    },
    {
        value: "Peru",
        label: "Peru"
    },
    {
        value: "Philippines",
        label: "Philippines"
    },
    {
        value: "Poland",
        label: "Poland"
    },
    {
        value: "Portugal",
        label: "Portugal"
    },
    {
        value: "Puerto Rico",
        label: "Puerto Rico"
    },
    {
        value: "Qatar",
        label: "Qatar"
    },
    {
        value: "Reunion",
        label: "Reunion"
    },
    {
        value: "Romania",
        label: "Romania"
    },
    {
        value: "Russia",
        label: "Russia"
    },
    {
        value: "Rwanda",
        label: "Rwanda"
    },
    {
        value: "Samoa",
        label: "Samoa"
    },
    {
        value: "San Marino",
        label: "San Marino"
    },
    {
        value: "Saudi Arabia",
        label: "Saudi Arabia"
    },
    {
        value: "Senegal",
        label: "Senegal"
    },
    {
        value: "Serbia",
        label: "Serbia"
    },
    {
        value: "Seychelles",
        label: "Seychelles"
    },
    {
        value: "Sierra Leone",
        label: "Sierra Leone"
    },
    {
        value: "Singapore",
        label: "Singapore"
    },
    {
        value: "Slovakia",
        label: "Slovakia"
    },
    {
        value: "Slovenia",
        label: "Slovenia"
    },
    {
        value: "Solomon Islands",
        label: "Solomon Islands"
    },
    {
        value: "South Africa",
        label: "South Africa"
    },
    {
        value: "South Georgia and the South Sandwich Islands",
        label: "South Georgia and the South Sandwich Islands"
    },
    {
        value: "South Korea",
        label: "South Korea"
    },
    {
        value: "Spain",
        label: "Spain"
    },
    {
        value: "Sri Lanka",
        label: "Sri Lanka"
    },
    {
        value: "Sudan",
        label: "Sudan"
    },
    {
        value: "Suriname",
        label: "Suriname"
    },
    {
        value: "Swaziland",
        label: "Swaziland"
    },
    {
        value: "Sweden",
        label: "Sweden"
    },
    {
        value: "Switzerland",
        label: "Switzerland"
    },
    {
        value: "Syria",
        label: "Syria"
    },
    {
        value: "Taiwan",
        label: "Taiwan"
    },
    {
        value: "Tajikistan",
        label: "Tajikistan"
    },
    {
        value: "Tanzania",
        label: "Tanzania"
    },
    {
        value: "Thailand",
        label: "Thailand"
    },
    {
        value: "Timor Leste",
        label: "Timor Leste"
    },
    {
        value: "Togo",
        label: "Togo"
    },
    {
        value: "Tokelau",
        label: "Tokelau"
    },
    {
        value: "Tonga",
        label: "Tonga"
    },
    {
        value: "Trinidad and Tobago",
        label: "Trinidad and Tobago"
    },
    {
        value: "Tunisia",
        label: "Tunisia"
    },
    {
        value: "Turkey",
        label: "Turkey"
    },
    {
        value: "Turkmenistan",
        label: "Turkmenistan"
    },
    {
        value: "Turks and Caicos Islands",
        label: "Turks and Caicos Islands"
    },
    {
        value: "Tuvalu",
        label: "Tuvalu"
    },
    {
        value: "U.S. Virgin Islands",
        label: "U.S. Virgin Islands"
    },
    {
        value: "Uganda",
        label: "Uganda"
    },
    {
        value: "Ukraine",
        label: "Ukraine"
    },
    {
        value: "United Arab Emirates",
        label: "United Arab Emirates"
    },
    {
        value: "United Kingdom",
        label: "United Kingdom"
    },
    {
        value: "United States",
        label: "United States"
    },
    {
        value: "Uruguay",
        label: "Uruguay"
    },
    {
        value: "Uzbekistan",
        label: "Uzbekistan"
    },
    {
        value: "Vanuatu",
        label: "Vanuatu"
    },
    {
        value: "Venezuela",
        label: "Venezuela"
    },
    {
        value: "Vietnam",
        label: "Vietnam"
    },
    {
        value: "Wake Island",
        label: "Wake Island"
    },
    {
        value: "Wallis and Futuna",
        label: "Wallis and Futuna"
    },
    {
        value: "Yemen",
        label: "Yemen"
    },
    {
        value: "Zambia",
        label: "Zambia"
    },
    {
        value: "Zanzibar",
        label: "Zanzibar"
    },
    {
        value: "Zimbabwe",
        label: "Zimbabwe"
    }
]

export const languages = [
    {
        value: "Abkhazian",
        label: "Abkhazian",
        code: "ab"
    },
    {
        value: "Afar",
        label: "Afar",
        code: "aa"
    },
    {
        value: "Afrikaans",
        label: "Afrikaans",
        code: "af"
    },
    {
        value: "Akan",
        label: "Akan",
        code: "ak"
    },
    {
        value: "Albanian",
        label: "Albanian",
        code: "sq"
    },
    {
        value: "Amharic",
        label: "Amharic",
        code: "am"
    },
    {
        value: "Arabic",
        label: "Arabic",
        code: "ar"
    },
    {
        value: "Aragonese",
        label: "Aragonese",
        code: "an"
    },
    {
        value: "Armenian",
        label: "Armenian",
        code: "hy"
    },
    {
        value: "Assamese",
        label: "Assamese",
        code: "as"
    },
    {
        value: "Asturian",
        label: "Asturian",
        code: "ast"
    },
    {
        value: "Avaric",
        label: "Avaric",
        code: "av"
    },
    {
        value: "Avestan",
        label: "Avestan",
        code: "ae"
    },
    {
        value: "Aymara",
        label: "Aymara",
        code: "ay"
    },
    {
        value: "Azerbaijani",
        label: "Azerbaijani",
        code: "az"
    },
    {
        value: "Bambara",
        label: "Bambara",
        code: "bm"
    },
    {
        value: "Bashkir",
        label: "Bashkir",
        code: "ba"
    },
    {
        value: "Basque",
        label: "Basque",
        code: "eu"
    },
    {
        value: "Belarusian",
        label: "Belarusian",
        code: "be"
    },
    {
        value: "Bengali",
        label: "Bengali",
        code: "bn"
    },
    {
        value: "Bihari languages",
        label: "Bihari languages",
        code: "bh"
    },
    {
        value: "Bislama",
        label: "Bislama",
        code: "bi"
    },
    {
        value: "Bosnian",
        label: "Bosnian",
        code: "bs"
    },
    {
        value: "Breton",
        label: "Breton",
        code: "br"
    },
    {
        value: "Bulgarian",
        label: "Bulgarian",
        code: "bg"
    },
    {
        value: "Burmese",
        label: "Burmese",
        code: "my"
    },
    {
        value: "Catalan",
        label: "Catalan",
        code: "ca"
    },
    {
        value: "Catalan, Valencian",
        label: "Catalan, Valencian",
        code: "ca"
    },
    {
        value: "Central Khmer",
        label: "Central Khmer",
        code: "km"
    },
    {
        value: "Central Kurdish",
        label: "Central Kurdish",
        code: "ckb"
    },
    {
        value: "Chamorro",
        label: "Chamorro",
        code: "ch"
    },
    {
        value: "Chechen",
        label: "Chechen",
        code: "ce"
    },
    {
        value: "Chichewa, Chewa, Nyanja",
        label: "Chichewa, Chewa, Nyanja",
        code: "ny"
    },
    {
        value: "Chinese",
        label: "Chinese",
        code: "zh"
    },
    {
        value: "Chinese (Hong Kong)",
        label: "Chinese (Hong Kong)",
        code: "zh-HK"
    },
    {
        value: "Chinese (Simplified)",
        label: "Chinese (Simplified)",
        code: "zh-CN"
    },
    {
        value: "Chinese (Traditional)",
        label: "Chinese (Traditional)",
        code: "zh-TW"
    },
    {
        value: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
        label: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
        code: "cu"
    },
    {
        value: "Chuvash",
        label: "Chuvash",
        code: "cv"
    },
    {
        value: "Cornish",
        label: "Cornish",
        code: "kw"
    },
    {
        value: "Corsican",
        label: "Corsican",
        code: "co"
    },
    {
        value: "Cree",
        label: "Cree",
        code: "cr"
    },
    {
        value: "Croatian",
        label: "Croatian",
        code: "hr"
    },
    {
        value: "Czech",
        label: "Czech",
        code: "cs"
    },
    {
        value: "Danish",
        label: "Danish",
        code: "da"
    },
    {
        value: "Divehi, Dhivehi, Maldivian",
        label: "Divehi, Dhivehi, Maldivian",
        code: "dv"
    },
    {
        value: "Dutch",
        label: "Dutch",
        code: "nl"
    },
    {
        value: "Dutch, Flemish",
        label: "Dutch, Flemish",
        code: "nl"
    },
    {
        value: "Dzongkha",
        label: "Dzongkha",
        code: "dz"
    },
    {
        value: "English",
        label: "English",
        code: "en"
    },
    {
        value: "English (Australia)",
        label: "English (Australia)",
        code: "en-AU"
    },
    {
        value: "English (Canada)",
        label: "English (Canada)",
        code: "en-CA"
    },
    {
        value: "English (India)",
        label: "English (India)",
        code: "en-IN"
    },
    {
        value: "English (New Zealand)",
        label: "English (New Zealand)",
        code: "en-NZ"
    },
    {
        value: "English (South Africa)",
        label: "English (South Africa)",
        code: "en-ZA"
    },
    {
        value: "English (United Kingdom)",
        label: "English (United Kingdom)",
        code: "en-GB"
    },
    {
        value: "English (United States)",
        label: "English (United States)",
        code: "en-US"
    },
    {
        value: "Esperanto",
        label: "Esperanto",
        code: "eo"
    },
    {
        value: "Estonian",
        label: "Estonian",
        code: "et"
    },
    {
        value: "Ewe",
        label: "Ewe",
        code: "ee"
    },
    {
        value: "Faroese",
        label: "Faroese",
        code: "fo"
    },
    {
        value: "Fijian",
        label: "Fijian",
        code: "fj"
    },
    {
        value: "Filipino",
        label: "Filipino",
        code: "fil"
    },
    {
        value: "Finnish",
        label: "Finnish",
        code: "fi"
    },
    {
        value: "French",
        label: "French",
        code: "fr"
    },
    {
        value: "French (Canada)",
        label: "French (Canada)",
        code: "fr-CA"
    },
    {
        value: "French (France)",
        label: "French (France)",
        code: "fr-FR"
    },
    {
        value: "French (Switzerland)",
        label: "French (Switzerland)",
        code: "fr-CH"
    },
    {
        value: "Fulah",
        label: "Fulah",
        code: "ff"
    },
    {
        value: "Gaelic, Scottish Gaelic",
        label: "Gaelic, Scottish Gaelic",
        code: "gd"
    },
    {
        value: "Galician",
        label: "Galician",
        code: "gl"
    },
    {
        value: "Ganda",
        label: "Ganda",
        code: "lg"
    },
    {
        value: "Georgian",
        label: "Georgian",
        code: "ka"
    },
    {
        value: "German",
        label: "German",
        code: "de"
    },
    {
        value: "German (Austria)",
        label: "German (Austria)",
        code: "de-AT"
    },
    {
        value: "German (Germany)",
        label: "German (Germany)",
        code: "de-DE"
    },
    {
        value: "German (Liechtenstein)",
        label: "German (Liechtenstein)",
        code: "de-LI"
    },
    {
        value: "German (Switzerland)",
        label: "German (Switzerland)",
        code: "de-CH"
    },
    {
        value: "Gikuyu, Kikuyu",
        label: "Gikuyu, Kikuyu",
        code: "ki"
    },
    {
        value: "Greek",
        label: "Greek",
        code: "el"
    },
    {
        value: "Greek (Modern)",
        label: "Greek (Modern)",
        code: "el"
    },
    {
        value: "Greenlandic, Kalaallisut",
        label: "Greenlandic, Kalaallisut",
        code: "kl"
    },
    {
        value: "Guarani",
        label: "Guarani",
        code: "gn"
    },
    {
        value: "Gujarati",
        label: "Gujarati",
        code: "gu"
    },
    {
        value: "Haitian, Haitian Creole",
        label: "Haitian, Haitian Creole",
        code: "ht"
    },
    {
        value: "Hausa",
        label: "Hausa",
        code: "ha"
    },
    {
        value: "Hawaiian",
        label: "Hawaiian",
        code: "haw"
    },
    {
        value: "Hebrew",
        label: "Hebrew",
        code: "he"
    },
    {
        value: "Herero",
        label: "Herero",
        code: "hz"
    },
    {
        value: "Hindi",
        label: "Hindi",
        code: "hi"
    },
    {
        value: "Hiri Motu",
        label: "Hiri Motu",
        code: "ho"
    },
    {
        value: "Hungarian",
        label: "Hungarian",
        code: "hu"
    },
    {
        value: "Icelandic",
        label: "Icelandic",
        code: "is"
    },
    {
        value: "Ido",
        label: "Ido",
        code: "io"
    },
    {
        value: "Igbo",
        label: "Igbo",
        code: "ig"
    },
    {
        value: "Indonesian",
        label: "Indonesian",
        code: "id"
    },
    {
        value: "Interlingua",
        label: "Interlingua",
        code: "ia"
    },
    {
        value: "Interlingua (International Auxiliary Language Association)",
        label: "Interlingua (International Auxiliary Language Association)",
        code: "ia"
    },
    {
        value: "Interlingue",
        label: "Interlingue",
        code: "ie"
    },
    {
        value: "Inuktitut",
        label: "Inuktitut",
        code: "iu"
    },
    {
        value: "Inupiaq",
        label: "Inupiaq",
        code: "ik"
    },
    {
        value: "Irish",
        label: "Irish",
        code: "ga"
    },
    {
        value: "Italian",
        label: "Italian",
        code: "it"
    },
    {
        value: "Italian (Italy)",
        label: "Italian (Italy)",
        code: "it-IT"
    },
    {
        value: "Italian (Switzerland)",
        label: "Italian (Switzerland)",
        code: "it-CH"
    },
    {
        value: "Japanese",
        label: "Japanese",
        code: "ja"
    },
    {
        value: "Javanese",
        label: "Javanese",
        code: "jv"
    },
    {
        value: "Kannada",
        label: "Kannada",
        code: "kn"
    },
    {
        value: "Kanuri",
        label: "Kanuri",
        code: "kr"
    },
    {
        value: "Kashmiri",
        label: "Kashmiri",
        code: "ks"
    },
    {
        value: "Kazakh",
        label: "Kazakh",
        code: "kk"
    },
    {
        value: "Khmer",
        label: "Khmer",
        code: "km"
    },
    {
        value: "Kinyarwanda",
        label: "Kinyarwanda",
        code: "rw"
    },
    {
        value: "Komi",
        label: "Komi",
        code: "kv"
    },
    {
        value: "Kongo",
        label: "Kongo",
        code: "kg"
    },
    {
        value: "Korean",
        label: "Korean",
        code: "ko"
    },
    {
        value: "Kurdish",
        label: "Kurdish",
        code: "ku"
    },
    {
        value: "Kwanyama, Kuanyama",
        label: "Kwanyama, Kuanyama",
        code: "kj"
    },
    {
        value: "Kyrgyz",
        label: "Kyrgyz",
        code: "ky"
    },
    {
        value: "Lao",
        label: "Lao",
        code: "lo"
    },
    {
        value: "Latin",
        label: "Latin",
        code: "la"
    },
    {
        value: "Latvian",
        label: "Latvian",
        code: "lv"
    },
    {
        value: "Letzeburgesch, Luxembourgish",
        label: "Letzeburgesch, Luxembourgish",
        code: "lb"
    },
    {
        value: "Limburgish, Limburgan, Limburger",
        label: "Limburgish, Limburgan, Limburger",
        code: "li"
    },
    {
        value: "Lingala",
        label: "Lingala",
        code: "ln"
    },
    {
        value: "Lithuanian",
        label: "Lithuanian",
        code: "lt"
    },
    {
        value: "Luba-Katanga",
        label: "Luba-Katanga",
        code: "lu"
    },
    {
        value: "Macedonian",
        label: "Macedonian",
        code: "mk"
    },
    {
        value: "Malagasy",
        label: "Malagasy",
        code: "mg"
    },
    {
        value: "Malay",
        label: "Malay",
        code: "ms"
    },
    {
        value: "Malayalam",
        label: "Malayalam",
        code: "ml"
    },
    {
        value: "Maltese",
        label: "Maltese",
        code: "mt"
    },
    {
        value: "Manx",
        label: "Manx",
        code: "gv"
    },
    {
        value: "Maori",
        label: "Maori",
        code: "mi"
    },
    {
        value: "Marathi",
        label: "Marathi",
        code: "mr"
    },
    {
        value: "Marshallese",
        label: "Marshallese",
        code: "mh"
    },
    {
        value: "Moldovan, Moldavian, Romanian",
        label: "Moldovan, Moldavian, Romanian",
        code: "ro"
    },
    {
        value: "Mongolian",
        label: "Mongolian",
        code: "mn"
    },
    {
        value: "Nauru",
        label: "Nauru",
        code: "na"
    },
    {
        value: "Navajo, Navaho",
        label: "Navajo, Navaho",
        code: "nv"
    },
    {
        value: "Ndonga",
        label: "Ndonga",
        code: "ng"
    },
    {
        value: "Nepali",
        label: "Nepali",
        code: "ne"
    },
    {
        value: "Northern Ndebele",
        label: "Northern Ndebele",
        code: "nd"
    },
    {
        value: "Northern Sami",
        label: "Northern Sami",
        code: "se"
    },
    {
        value: "Norwegian",
        label: "Norwegian",
        code: "no"
    },
    {
        value: "Norwegian Bokmål",
        label: "Norwegian Bokmål",
        code: "nb"
    },
    {
        value: "Norwegian Nynorsk",
        label: "Norwegian Nynorsk",
        code: "nn"
    },
    {
        value: "Nuosu, Sichuan Yi",
        label: "Nuosu, Sichuan Yi",
        code: "ii"
    },
    {
        value: "Occitan",
        label: "Occitan",
        code: "oc"
    },
    {
        value: "Occitan (post 1500)",
        label: "Occitan (post 1500)",
        code: "oc"
    },
    {
        value: "Ojibwa",
        label: "Ojibwa",
        code: "oj"
    },
    {
        value: "Oriya",
        label: "Oriya",
        code: "or"
    },
    {
        value: "Oromo",
        label: "Oromo",
        code: "om"
    },
    {
        value: "Ossetian, Ossetic",
        label: "Ossetian, Ossetic",
        code: "os"
    },
    {
        value: "Pali",
        label: "Pali",
        code: "pi"
    },
    {
        value: "Panjabi, Punjabi",
        label: "Panjabi, Punjabi",
        code: "pa"
    },
    {
        value: "Pashto",
        label: "Pashto",
        code: "ps"
    },
    {
        value: "Pashto, Pushto",
        label: "Pashto, Pushto",
        code: "ps"
    },
    {
        value: "Persian",
        label: "Persian",
        code: "fa"
    },
    {
        value: "Polish",
        label: "Polish",
        code: "pl"
    },
    {
        value: "Portuguese",
        label: "Portuguese",
        code: "pt"
    },
    {
        value: "Portuguese (Brazil)",
        label: "Portuguese (Brazil)",
        code: "pt-BR"
    },
    {
        value: "Portuguese (Portugal)",
        label: "Portuguese (Portugal)",
        code: "pt-PT"
    },
    {
        value: "Punjabi",
        label: "Punjabi",
        code: "pa"
    },
    {
        value: "Quechua",
        label: "Quechua",
        code: "qu"
    },
    {
        value: "Romanian",
        label: "Romanian",
        code: "ro"
    },
    {
        value: "Romanian (Moldova)",
        label: "Romanian (Moldova)",
        code: "mo"
    },
    {
        value: "Romansh",
        label: "Romansh",
        code: "rm"
    },
    {
        value: "Rundi",
        label: "Rundi",
        code: "rn"
    },
    {
        value: "Russian",
        label: "Russian",
        code: "ru"
    },
    {
        value: "Samoan",
        label: "Samoan",
        code: "sm"
    },
    {
        value: "Sango",
        label: "Sango",
        code: "sg"
    },
    {
        value: "Sanskrit",
        label: "Sanskrit",
        code: "sa"
    },
    {
        value: "Sardinian",
        label: "Sardinian",
        code: "sc"
    },
    {
        value: "Scottish Gaelic",
        label: "Scottish Gaelic",
        code: "gd"
    },
    {
        value: "Serbian",
        label: "Serbian",
        code: "sr"
    },
    {
        value: "Serbo",
        label: "Serbo",
        code: "sh"
    },
    {
        value: "Shona",
        label: "Shona",
        code: "sn"
    },
    {
        value: "Sindhi",
        label: "Sindhi",
        code: "sd"
    },
    {
        value: "Sinhala",
        label: "Sinhala",
        code: "si"
    },
    {
        value: "Sinhala, Sinhalese",
        label: "Sinhala, Sinhalese",
        code: "si"
    },
    {
        value: "Slovak",
        label: "Slovak",
        code: "sk"
    },
    {
        value: "Slovenian",
        label: "Slovenian",
        code: "sl"
    },
    {
        value: "Somali",
        label: "Somali",
        code: "so"
    },
    {
        value: "Sotho, Southern",
        label: "Sotho, Southern",
        code: "st"
    },
    {
        value: "South Ndebele",
        label: "South Ndebele",
        code: "nr"
    },
    {
        value: "Southern Sotho",
        label: "Southern Sotho",
        code: "st"
    },
    {
        value: "Spanish",
        label: "Spanish",
        code: "es"
    },
    {
        value: "Spanish (Argentina)",
        label: "Spanish (Argentina)",
        code: "es-AR"
    },
    {
        value: "Spanish (Latin America)",
        label: "Spanish (Latin America)",
        code: "es-419"
    },
    {
        value: "Spanish (Mexico)",
        label: "Spanish (Mexico)",
        code: "es-MX"
    },
    {
        value: "Spanish (Spain)",
        label: "Spanish (Spain)",
        code: "es-ES"
    },
    {
        value: "Spanish (United States)",
        label: "Spanish (United States)",
        code: "es-US"
    },
    {
        value: "Spanish, Castilian",
        label: "Spanish, Castilian",
        code: "es"
    },
    {
        value: "Sundanese",
        label: "Sundanese",
        code: "su"
    },
    {
        value: "Swahili",
        label: "Swahili",
        code: "sw"
    },
    {
        value: "Swati",
        label: "Swati",
        code: "ss"
    },
    {
        value: "Swedish",
        label: "Swedish",
        code: "sv"
    },
    {
        value: "Tagalog",
        label: "Tagalog",
        code: "tl"
    },
    {
        value: "Tahitian",
        label: "Tahitian",
        code: "ty"
    },
    {
        value: "Tajik",
        label: "Tajik",
        code: "tg"
    },
    {
        value: "Tamil",
        label: "Tamil",
        code: "ta"
    },
    {
        value: "Tatar",
        label: "Tatar",
        code: "tt"
    },
    {
        value: "Telugu",
        label: "Telugu",
        code: "te"
    },
    {
        value: "Thai",
        label: "Thai",
        code: "th"
    },
    {
        value: "Tibetan",
        label: "Tibetan",
        code: "bo"
    },
    {
        value: "Tigrinya",
        label: "Tigrinya",
        code: "ti"
    },
    {
        value: "Tonga (Tonga Islands)",
        label: "Tonga (Tonga Islands)",
        code: "to"
    },
    {
        value: "Tongan",
        label: "Tongan",
        code: "to"
    },
    {
        value: "Tsonga",
        label: "Tsonga",
        code: "ts"
    },
    {
        value: "Tswana",
        label: "Tswana",
        code: "tn"
    },
    {
        value: "Turkish",
        label: "Turkish",
        code: "tr"
    },
    {
        value: "Turkmen",
        label: "Turkmen",
        code: "tk"
    },
    {
        value: "Twi",
        label: "Twi",
        code: "tw"
    },
    {
        value: "Uighur, Uyghur",
        label: "Uighur, Uyghur",
        code: "ug"
    },
    {
        value: "Ukrainian",
        label: "Ukrainian",
        code: "uk"
    },
    {
        value: "Urdu",
        label: "Urdu",
        code: "ur"
    },
    {
        value: "Uyghur",
        label: "Uyghur",
        code: "ug"
    },
    {
        value: "Uzbek",
        label: "Uzbek",
        code: "uz"
    },
    {
        value: "Venda",
        label: "Venda",
        code: "ve"
    },
    {
        value: "Vietnamese",
        label: "Vietnamese",
        code: "vi"
    },
    {
        value: "Volap_k",
        label: "Volap_k",
        code: "vo"
    },
    {
        value: "Walloon",
        label: "Walloon",
        code: "wa"
    },
    {
        value: "Welsh",
        label: "Welsh",
        code: "cy"
    },
    {
        value: "Western Frisian",
        label: "Western Frisian",
        code: "fy"
    },
    {
        value: "Wolof",
        label: "Wolof",
        code: "wo"
    },
    {
        value: "Xhosa",
        label: "Xhosa",
        code: "xh"
    },
    {
        value: "Yiddish",
        label: "Yiddish",
        code: "yi"
    },
    {
        value: "Yoruba",
        label: "Yoruba",
        code: "yo"
    },
    {
        value: "Zhuang, Chuang",
        label: "Zhuang, Chuang",
        code: "za"
    },
    {
        value: "Zulu",
        label: "Zulu",
        code: "zu"
    }
]